import React, { useRef } from "react";

import { defineBlock, smartProps, useEditor } from "@smartfire/gutenberg-react";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import style from "./block.module.scss";
import EditableText from "../shared/editable-text";
import arrow from "./arrow.svg";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ALLOWED_MEDIA_TYPES = ["image"];

function Block({ slides }) {
  const sliderRef = useRef();
  const { isEditing, updateData } = useEditor();

  function previous() {
    sliderRef.current.slickPrev();
  }
  function next() {
    sliderRef.current.slickNext();
  }

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 1000,
    slidesToShow: Math.min(3, slides.length),
    slidesToScroll: 1,
    initialSlide: slides.length,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: Math.min(1, slides.length),
        },
      },
    ],
  };

  function updateValue(key, value, i) {
    slides[i][key] = value;
    updateData({ slides: [...slides] });
  }

  const addSlide = () => {
    let newSlide = {
      date: "",
      title: "",
      description: "",
      background: { url: "" },
    };
    updateData({ slides: [...slides, newSlide] });
  };

  const deleteSlide = (i) => {
    slides.splice(i, 1);
    updateData({ slides: [...slides] });
  };

  const SlidesAdmin = () => {
    return (
      <div className={style.slidesAdmin + " partners-slider-container"}>
        {slides &&
          slides.map((item, i) => (
            <div className={style.slide} key={i}>
              <div className={style.contentAdmin}>
                <img
                  className={style.image}
                  src={item.background.url}
                  alt={""}
                />
                <MediaUploadCheck>
                  <MediaUpload
                    allowedTypes={ALLOWED_MEDIA_TYPES}
                    value={item.background ? item.background.id : null}
                    render={({ open }) => (
                      <button className={style.editButton} onClick={open}>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M21.2635 2.29289C20.873 1.90237 20.2398 1.90237 19.8493 2.29289L18.9769 3.16525C17.8618 2.63254 16.4857 2.82801 15.5621 3.75165L4.95549 14.3582L10.6123 20.0151L21.2189 9.4085C22.1426 8.48486 22.338 7.1088 21.8053 5.99367L22.6777 5.12132C23.0682 4.7308 23.0682 4.09763 22.6777 3.70711L21.2635 2.29289ZM16.9955 10.8035L10.6123 17.1867L7.78392 14.3582L14.1671 7.9751L16.9955 10.8035ZM18.8138 8.98525L19.8047 7.99429C20.1953 7.60376 20.1953 6.9706 19.8047 6.58007L18.3905 5.16586C18 4.77534 17.3668 4.77534 16.9763 5.16586L15.9853 6.15683L18.8138 8.98525Z"
                            fill="currentColor"
                          />
                          <path
                            d="M2 22.9502L4.12171 15.1717L9.77817 20.8289L2 22.9502Z"
                            fill="currentColor"
                          />
                        </svg>
                      </button>
                    )}
                    onSelect={(media) => updateValue("background", media, i)}
                  />
                </MediaUploadCheck>
                <div className={style.linkInputContainer}>
                  <input
                    placeholder="Lien"
                    value={item.link}
                    onChange={(e) => {
                      updateValue("link", e.target.value, i);
                    }}
                    type="text"
                    id="link"
                    name="link"
                  />
                </div>
                <button
                  className={style.deleteButton}
                  onClick={() => deleteSlide(i)}
                >
                  <svg
                    aria-hidden="true"
                    role="img"
                    focusable="false"
                    class="dashicon dashicons-trash"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  >
                    <path d="M12 4h3c.6 0 1 .4 1 1v1H3V5c0-.6.5-1 1-1h3c.2-1.1 1.3-2 2.5-2s2.3.9 2.5 2zM8 4h3c-.2-.6-.9-1-1.5-1S8.2 3.4 8 4zM4 7h11l-.9 10.1c0 .5-.5.9-1 .9H5.9c-.5 0-.9-.4-1-.9L4 7z"></path>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        <button className={style.addButton} onClick={() => addSlide()}>
          <svg
            aria-hidden="true"
            role="img"
            focusable="false"
            class="dashicon dashicons-insert"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <path d="M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"></path>
          </svg>
        </button>
      </div>
    );
  };

  return (
    <div className={style.block}>
      <div className={style.block_inner}>
        <EditableText
          className={style.titre}
          formattingControls={["bold", "italic"]}
          smartProp="title"
          placeholder={"Entrez un titre"}
        />
        <div className={style.spacer} />
        <div className={style.separator} />
        <div className={style.spacer} />
        <div className={style.spacer} />
        <div className={style.sliderContainer}>
          {isEditing ? (
            <>{SlidesAdmin()}</>
          ) : (
            <>
              <Slider ref={sliderRef} className={style.slider} {...settings}>
                {slides &&
                  slides.map((item) => (
                    <div className={style.slide}>
                      <a
                        className={style.link}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={style.image}
                          src={item.background.url}
                          alt=""
                        />
                      </a>
                    </div>
                  ))}
                {slides &&
                  slides.map((item) => (
                    <div className={style.slide}>
                      <a
                        className={style.link}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={style.image}
                          src={item.background.url}
                          alt=""
                        />
                      </a>
                    </div>
                  ))}
                {slides &&
                  slides.map((item) => (
                    <div className={style.slide}>
                      <a
                        className={style.link}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={style.image}
                          src={item.background.url}
                          alt=""
                        />
                      </a>
                    </div>
                  ))}
              </Slider>
              <img
                src={arrow}
                alt="prev"
                onClick={() => previous()}
                className={style.sliderArrow}
              />
              <img
                src={arrow}
                alt="next"
                onClick={() => next()}
                className={`${style.sliderArrow} ${style.right}`}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault("Nos partenaires"),
    img: smartProps.any.withDefault(""),
    slides: smartProps.any.withDefault([]),
  },
  setup: {
    title: "Partenaires slider",
  },
});
